export const SeparatedViewSeparator = '&';
